// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"e4991f6c","205":"717a37c3","274":"b46c3cdc","353":"98f78bcd","456":"372ec0f5","546":"75843d38","678":"33eb4dd5","744":"3130605f","885":"7589ca0a","963":"9db7f463"}[chunkId] + ".chunk.js";
};